import type { ReactNode } from "react";
import { MATURITY_COLORS } from "@shared/scoring";

// Maturity scale (1 Ideating → 5 Leading) — matches the ey-ai-demo.com reference.
// Colors come from the shared MATURITY_COLORS so the poll and the Readiness Radar
// stay in lockstep.
export interface ScaleStep {
  val: number;
  label: string;
  blurb: string; // one-line reminder of what this score means
  c: string; // per-step accent color (= readiness-scale color)
  icon: ReactNode;
}

export const MATURITY_SCALE: ScaleStep[] = [
  {
    val: 1, label: "Ideating", blurb: "Beginning to explore how AI will impact the workforce", c: MATURITY_COLORS[0],
    icon: <svg viewBox="0 0 24 24"><path d="M9 18h6M10 22h4M12 2a7 7 0 0 1 7 7c0 2.5-1.5 4.5-3.5 5.5V17H8.5v-2.5C6.5 13.5 5 11.5 5 9a7 7 0 0 1 7-7z" /></svg>,
  },
  {
    val: 2, label: "Experimenting", blurb: "Piloting AI tools and frameworks to inform planning", c: MATURITY_COLORS[1],
    icon: <svg viewBox="0 0 24 24"><path d="M9 3H5a2 2 0 0 0-2 2v4M9 3h6M9 3v18m6-18h4a2 2 0 0 1 2 2v4M15 3v18M9 21h6M4 9h16M4 15h16" /></svg>,
  },
  {
    val: 3, label: "Optimizing", blurb: "Formal strategies in place; data and processes aligned", c: MATURITY_COLORS[2],
    icon: <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>,
  },
  {
    val: 4, label: "Transforming", blurb: "AI actively enabling people and structure enterprise-wide", c: MATURITY_COLORS[3],
    icon: <svg viewBox="0 0 24 24"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>,
  },
  {
    val: 5, label: "Leading", blurb: "AI fully embedded, driving sustained value and innovation", c: MATURITY_COLORS[4],
    icon: <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
  },
];
